import { desktopTemplate } from '../template/DesktopTemplate.ts';
import { mobileTemplate } from '../template/MobileTemplate.ts';
import { langTemplate } from '../template/LangTemplate.ts';
import { Lang } from '../entities/Lang.ts';
import {IParams} from "../types/params.interface.ts";
import {ILanguage} from "../types/language.interface.ts";
import {config} from "../config/config.ts";

class WidgetWrapper {
	container: Element
	params: IParams
	languages: Lang[]
	desktop = desktopTemplate
	mobile = mobileTemplate

	setContainer (container: Element) {
		this.container = container
		return this
	}

	setParams (params: IParams) {
		this.params = params
		this.languages = params.languages.map(this._createLang.bind(this))
		return this
	}

	render () {
		let gtWidget = /* html */ `<div id="original-google-translate" class="d-none"></div>`
		this.container.innerHTML = gtWidget + this.desktop.getHtml(this.languages) + this.mobile.getHtml(this.languages)
		return this
	}
	
	_createLang (element: ILanguage) {
		const language = new Lang()
		language.name = element.name
		language.shortCode = element.shortCode
		language.template = langTemplate
		return language
	}

	addListeners () {
		const toggleButtons = [...document.querySelectorAll(config.activeItem.selector)]
		const languageOptions = [...document.querySelectorAll(config.list.selector)]
		toggleButtons.map((button, i) => button.addEventListener('click', () => this.handleClick(button, languageOptions[i])))
		return this
	}

	handleClick = (
		toggleButton: Element,
		languageOption: Element
	) => {
		toggleButton.classList.toggle(config.activeItem.activeClass)
		languageOption.classList.toggle(config.list.activeClass)
		if (toggleButton.classList.contains(config.activeItem.activeClass)) {
			setTimeout(() => document.addEventListener('click',() => {
					toggleButton.classList.remove(config.activeItem.activeClass)
					languageOption.classList.remove(config.list.activeClass)
			}, {once: true}), 100)
		}
	}

}

const widgetWrapper = new WidgetWrapper()
export {
	WidgetWrapper,
	widgetWrapper
}
